import { render, staticRenderFns } from "./FrequencyHint.vue?vue&type=template&id=aac65354"
import script from "./FrequencyHint.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequencyHint.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports